import c, { useMemo as g } from "react";
import E from "./index234.mjs";
import I from "./index235.mjs";
import b from "./index236.mjs";
import { useAlert as T } from "./index119.mjs";
import { track as i } from "./index9.mjs";
import { TRACK_EVENT_TYPE as l, TRACK_EVENT as p } from "./index10.mjs";
import { useHotelConfig as k } from "./index93.mjs";
import { getSubscriptionPlanRoot as s } from "./index14.mjs";
import { getConfigPropertyAtomCreator as d, ConfigProperty as L, ViewLayout as R } from "./index13.mjs";
import { useAtomValue as A } from "jotai";
const U = ({ onClose: m }) => {
  const _ = T(), { hotelId: o, propertySize: t, propertyType: e, subscriptionPlan: n } = k(), C = A(
    g(() => d(L.VIEW_LAYOUT), [])
  ), f = () => {
    i(p.CLICK, l.EXIT_CONFIRMED, {
      hotel_id: o,
      property_type: e,
      property_size: t,
      subscription_plan: s(n)
    }), m();
  }, u = () => {
    i(p.CLICK, l.RETURN_AFTER_EXIT_INTENT, {
      hotel_id: o,
      property_type: e,
      property_size: t,
      subscription_plan: s(n)
    });
  }, a = () => {
    i(p.CLICK, l.EXIT_CLICKED, {
      hotel_id: o,
      property_type: e,
      property_size: t,
      subscription_plan: s(n)
    }), _({
      icon: E,
      title: I18n.t("booking_engine.information.exit_warning"),
      subTitle: I18n.t("booking_engine.information.exit_warning_description"),
      actions: [
        {
          label: I18n.t("booking_engine.information.exit_confirm"),
          secondary: !0,
          onClick: f
        },
        {
          label: I18n.t("booking_engine.information.exit_cancel"),
          onClick: u
        }
      ]
    });
  }, y = (r) => {
    (r.key === "Enter" || r.key === " ") && (r.preventDefault(), a());
  };
  return C === R.FULL_SCREEN ? null : /* @__PURE__ */ c.createElement(
    "button",
    {
      type: "button",
      className: b.close,
      onClick: a,
      onKeyDown: y,
      "data-testid": "close-button",
      "aria-label": I18n.t("booking_engine.information.close")
    },
    /* @__PURE__ */ c.createElement(I, null)
  );
};
export {
  U as Close
};
